import { all } from "redux-saga/effects";
import { copyHotspotsFromUrlWatcher, loadUrlWatcher } from "./loaderSaga";
import {
  setHoverActionDebouncedWatcher,
  setClickActionBoxContentDebouncedWatcher,
} from "./rteSaga";
import { addHotspotFromUIWatcher } from "./addHotspotFromUISaga";
import { loadSpinWatcher } from "./loadSpin";
import { updateSpinInfoHotspotsWatcher } from "./updateSpinInfoHotspotsSaga";
import { demonstrateHotspotPathWatcher } from "./demonstrateHotspotPath";
import { locationSetIntentWatcher } from "./locationSetIntentSaga";
import { requestImageWatcher } from "./requestImage";
import { setDimensionsWatcher } from "./setDimensions";
import { setCurrentFrameIndexWatcher } from "./setCurrentFrameIndex";

export default function* rootSaga() {
  yield all([
    loadUrlWatcher(),
    setHoverActionDebouncedWatcher(),
    setClickActionBoxContentDebouncedWatcher(),
    copyHotspotsFromUrlWatcher(),
    addHotspotFromUIWatcher(),
    loadSpinWatcher(),
    updateSpinInfoHotspotsWatcher(),
    demonstrateHotspotPathWatcher(),
    locationSetIntentWatcher(),
    requestImageWatcher(),
    setDimensionsWatcher(),
    setCurrentFrameIndexWatcher(),
  ]);
}
